import V3Check from './V3Check'
import { CheckUtils } from 'utils'

export default class V3BlogFrequencyCheck extends React.Component {
  constructor(props) {
    super(props)

    this.renderInfo = this.renderInfo.bind(this)
    this.renderDetails = this.renderDetails.bind(this)
  }

  render() {
    const props = {
      ...this.props,
      info: this.renderInfo,
      details: this.renderDetails
    }

    return <V3Check { ...props } />
  }

  renderDetails() {
    return CheckUtils.renderDetailsList(this.props.check.checkItems)
  }

  renderInfo() {
    return (
      <div>
        <h2>Key points</h2>
        <p>
          Blogging frequently is a key way to get search engines to visit your site more frequently. Recent, unique content is often favoured over things like product pages by search engines.
        </p>
        <hr />
        <h2>How it's used</h2>
        <ul>
          <li>Fresh content is easier to discover on blogs than content pages by search engines</li>
          <li>To both build an audience and entice search engines a regular frequency is important</li>
        </ul>
        <hr />
        <h2>Best practice</h2>
        <ul>
          <li>Space blog posts out evenly: four posts over four weeks is better than four posts in a day and then none for a month</li>
          <li>Plug in SEO data shows that blogging at least once a week demonstrates a tangible improvement in search engine impressions</li>
        </ul>
        <hr />
        <h2>Fix this yourself</h2>
        <p>
          Planning the topics you'll write about in an editorial calendar helps create a coherent and regular schedule.
        </p>
        <p>
          With Shopify you can schedule blog posts to be published on a future date. This way you can write when you feel inspired and still achieve a regular flow of new content.
        </p>
        <ol>
          <li>When editing a blog post scroll to the 'Visibility' section</li>
          <li>Press 'Set a specific publish date...'</li>
          <li>Choose the date you'd like the blog post to be published</li>
          <li>Press Save</li>
        </ol>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/v3_checks/V3BlogFrequencyCheck.js